import React from "react";

export default function TableViewer ({ data }: { data: Record<string, any>[] }) {
  if (!data.length) return null;

  const headers = Object.keys(data[0]);

  return (
    <table className="w-full text-sm border border-gray-300">
      <thead>
        <tr>
          {headers.map((header) => (
            <th key={header} className="text-left px-2 py-1 bg-zinc-800 border border-gray-300">
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, idx) => (
          <tr key={idx}>
            {headers.map((header) => (
              <td key={header} className="px-2 py-1 border border-gray-200">
                {row[header]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

